export const JobRoleValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.JobRole.trim()) {
      errors.JobRole = ' This field is required';
    } 
   
    return errors;
  };
  
 